import { ruPluralization } from '@/js/i18n/ru-pluralization.ts';
import { createI18n } from 'vue-i18n';

export const i18n = createI18n({
  locale: 'ru',
  fallbackLocale: 'ru',
  messages: {
    ru: {
      products: '0 товаров|{n} товар|{n} товара|{n} товаров',
    },
    uz: {
      products: '{n} ta mahsulot',
    },
  },
  pluralizationRules: {
    ru: ruPluralization,
  },
});
